import { Components } from "antd/lib/date-picker/generatePicker";
import { resellerLicense } from "../../constants/actionTypes";

const requestGetResellerlicenceList = (params) => ({
  type: resellerLicense.GET_RESELLERLICENSE_LIST,
  payload: params,
});



const successResellerLicenseList = (data) => ({
  type: resellerLicense.SUCCESS_GET_RESELLERLICENSE_LIST,
  payload: data,
});

const errorResellerLicenseList = (data) => ({
  type: resellerLicense.ERROR_GET_RESELLERLICENSE_LIST,
  payload: data,
});

const successResellerLicenseItem = (data) => ({
  type: resellerLicense.SUCCESS_GET_RESELLERLICENSE_ITEM,
  payload: data,
});

const errorResellerLicenseItem = (data) => ({
  type: resellerLicense.ERROR_GET_RESELLERLICENSE_ITEM,
  payload: data,
});

const requestDeleteLicense = (data) => ({
  type: resellerLicense.REQUEST_DELETE_LICENSE,
  payload: data,
});

const clearResellerLicense = () => ({
  type: resellerLicense.CLEAR_LICENSE_ITEM,
});

const requestSetLicenseList = (data) => ({
  type: resellerLicense.REQUEST_SET_LICENSE,
  payload: data,
});

const requestUpdateLicenseList = (id, data) => ({
  type: resellerLicense.REQUEST_UPDATE_LICENSE,
  id,
  payload: data,
});

const successDeleteLicense = (data) => ({
  type: resellerLicense.SUCCESS_DELETE_LICENSE,
  payload: data,
});

const errorDeleteLicense = (data) => ({
  type: resellerLicense.ERROR_DELETE_LICENSE,
  payload: data,
});

const successUpdateLicense = (data) => ({
  type: resellerLicense.SUCCESS_UPDATE_LICENSE,
  payload: data,
});

const errorUpdateLicense = (data) => ({
  type: resellerLicense.ERROR_UPDATE_LICENSE,
  payload: data,
});

const errorLicenseSet = (data) => ({
  type: resellerLicense.ERROR_SET_LICENSE,
  payload: data,
});

const successLicenseSet = (data) => ({
  type: resellerLicense.SUCCESS_SET_LICENSE,
  payload: data,
});

const getRlicenseDetails = (data) => ({
  type: resellerLicense.GET_RESELLERLICENSE_LIST_BYID,
  payload: data,
});
const setRlienseDetailsById = (data) => ({
  type: resellerLicense.SUCCESS_GET_RESELLERLICENSE_LIST_BYID,
  payload: data,
});

const setRlicenseDetailsErrorById = (data) => ({
  type: resellerLicense.ERROR_GET_RESELLERLICENSE_LIST_BYID,
});

const setLicenseSummaryError = (data) => ({
  type: resellerLicense.ERROR_LICENSE_SUMMARY,
  payload: data,
});

const getLicenseSummary = (data) => ({
  type: resellerLicense.GET_LICENSE_SUMMARY,
  payload: data,
});

const setLicenseSummary = (data) => ({
  type:resellerLicense.SET_LICENSE_SUMMARY,
  payload:data,
})

const setLicensListData = (data) => ({
  type: resellerLicense.SET_LICENSE_LIST_DATA,
  payload: data,
});

const clearLicenseItem = () => ({
  type:resellerLicense.CLEAR_LICENSE_ITEM,
});

const resellerLicenseCustomerView = (params) => ({
  type: resellerLicense.GET_RESELLERLICENSE_CUSTOMER_VIEW,
  payload: params,
});

const errorResellerLicenseCustomerView= (data) => ({
  type: resellerLicense.ERROR_GET_RESELLERLICENSE_CUSTOMER_VIEW,
  payload: data,
});

const successResellerLicenseCustomerView = (data) => ({
  type: resellerLicense.SUCCESS_GET_RESELLERLICENSE_CUSTOMER_VIEW,
  payload: data,
});


export {
  requestGetResellerlicenceList,
  successResellerLicenseList,
  errorResellerLicenseList,
  successResellerLicenseItem,
  errorResellerLicenseItem,
  requestDeleteLicense,
  clearResellerLicense,
  requestSetLicenseList,
  requestUpdateLicenseList,
  successDeleteLicense,
  errorDeleteLicense,
  successUpdateLicense,
  errorUpdateLicense,
  errorLicenseSet,
  successLicenseSet,
  setRlienseDetailsById,
  setRlicenseDetailsErrorById,
  getRlicenseDetails,
  setLicenseSummaryError,
  getLicenseSummary,
  setLicenseSummary,
  resellerLicenseCustomerView,
  successResellerLicenseCustomerView,
  errorResellerLicenseCustomerView,
};
